import _ from 'lodash';
import {MutationTree} from 'vuex';
import BioAdmin from 'types/ba/bioAdmin';
import LtFramework from 'types/lt/ltFramework';
import {BioServicesConstant} from '../../lib/constants';

export const AlertNotificationMutations: MutationTree<LtFramework.IAlertNotificationState> = {
	setAlertNotifications(state: LtFramework.IAlertNotificationState, payload: LtFramework.IAlertNotification[]) {
		state.alertNotifications = payload;
	},
};

export const BioProfileMutations: MutationTree<BioAdmin.IBioProfileState> = {
	setProfile(state: BioAdmin.IBioProfileState, payload: BioAdmin.IBioProfile) {
		state.bioProfile = payload;
	},
	modifyProfileClubs(state: BioAdmin.IBioProfileState, club: BioAdmin.IProfileClub) {
		if (club.selected) {
			// remove selected attribute from object
			delete club.selected;
			state.bioProfile.clubs.push(club);
		} else {
			const clubIndex = _.findIndex(state.bioProfile.clubs, (profileClub: BioAdmin.IProfileClub) => {
				return profileClub.clubId === club.clubId;
			});
			state.bioProfile.clubs.splice(clubIndex, 1);
		}
	},
	removeProfileClub(state: BioAdmin.IBioProfileState, index: number) {
		state.bioProfile.clubs.splice(index, 1);
	},
	updateAvatarId(state: BioAdmin.IBioProfileState, val: number) {
		state.bioProfile.avatarId = val;
	},
	updateQuote(state: BioAdmin.IBioProfileState, val: string) {
		state.bioProfile.quote = val;
	},
	updateQuoteCitation(state: BioAdmin.IBioProfileState, val: string) {
		state.bioProfile.quoteCitation = val;
	},
	updateAboutMe(state: BioAdmin.IBioProfileState, val: string) {
		state.bioProfile.aboutMe = val;
	},
	modifyProfileLanguages(state: BioAdmin.IBioProfileState, data: BioAdmin.IListLanguage) {
		const lanaguagesIndex = _.findIndex(state.bioProfile.tagGroups, (group: any) => {
			return group.name === BioServicesConstant.languagesName;
		});
		if (data.selected) {
			delete data.selected;
			state.bioProfile.tagGroups[lanaguagesIndex].tags.push(data);
		} else {
			const removeIndex = _.findIndex(state.bioProfile.tagGroups[lanaguagesIndex].tags, (tag: BioAdmin.ITag) => {
				return tag.name === data.name;
			});
			state.bioProfile.tagGroups[lanaguagesIndex].tags.splice(removeIndex, 1);
		}
	},
	removeProfileLanguage(state: BioAdmin.IBioProfileState, index: number) {
		const tgIndex = _.findIndex(state.bioProfile.tagGroups, (group: any) => {
			return group.name === BioServicesConstant.languagesName;
		});
		state.bioProfile.tagGroups[tgIndex].tags.splice(index, 1);
	},
	updateProfileSocialLink(state: BioAdmin.IBioProfileState, ev: any) {
		const index = _.findIndex(state.bioProfile.socialLinks, (obj: any) => {
			return obj.type === ev.target.id;
		});
		if (index < 0) {
			const socialLink = {
				type: ev.target.id,
				link: ev.target.value,
			};
			state.bioProfile.socialLinks.push(socialLink);
		} else {
			state.bioProfile.socialLinks[index].link = ev.target.value;
		}
	},
	modifyProfileServices(state: BioAdmin.IBioProfileState, service: BioAdmin.IServiceTag) {
		const hasService = _.some(state.bioProfile.services, (s: BioAdmin.IServiceTag) => {
			return s.id === service.id;
		});
		if (!hasService) {
			// if the service is not present in profile, add it
			state.bioProfile.services.push(service);
		} else {
			// otherwise remove the service from profile
			const removeIndex = _.findIndex(state.bioProfile.services, (profileService: BioAdmin.IServiceTag) => {
				return profileService.id === service.id;
			});
			state.bioProfile.services.splice(removeIndex, 1);
		}
	},
	removeProfileService(state: BioAdmin.IBioProfileState, index: number) {
		state.bioProfile.services.splice(index, 1);
	},
	modifyProfileSpecialties(state: BioAdmin.IBioProfileState, tag: BioAdmin.ITag) {
		const index = _.findIndex(state.bioProfile.tagGroups, (group: any) => {
			return group.name === BioServicesConstant.specialtiesName;
		});

		const hasSpecialty = _.some(state.bioProfile.tagGroups[index].tags, (pt: BioAdmin.ITag) => {
			return pt.id === tag.id;
		});

		if (!hasSpecialty) {
			state.bioProfile.tagGroups[index].tags.push(tag);
		} else {
			const removeIndex = _.findIndex(state.bioProfile.tagGroups[index].tags, (specialtyTag: BioAdmin.ITag) => {
				return specialtyTag.id === tag.id;
			});
			state.bioProfile.tagGroups[index].tags.splice(removeIndex, 1);
		}
	},
	removeProfileSpecialty(state: BioAdmin.IBioProfileState, index: number) {
		const tgIndex = _.findIndex(state.bioProfile.tagGroups, (group: any) => {
			return group.name === BioServicesConstant.specialtiesName;
		});
		state.bioProfile.tagGroups[tgIndex].tags.splice(index, 1);
	},
	modifySchedule(state: BioAdmin.IBioProfileState, updateObj: any) {
		const clubIndex = _.findIndex(state.bioProfile.clubs, (club: any) => {
			return club.clubId === updateObj.clubId;
		});
		// @ts-ignore
		state.bioProfile.clubs[clubIndex].schedule[updateObj.dayIndex].items[updateObj.timeIndex] = {...state.bioProfile.clubs[clubIndex].schedule[updateObj.dayIndex].items[updateObj.timeIndex], active: updateObj.value};
	},
};

export const EmployeeProfileMutations: MutationTree<LtFramework.IEmployeeProfileState> = {
	setEmployeeProfile(state: LtFramework.IEmployeeProfileState, payload: LtFramework.IEmployeeProfile) {
		state.employeeProfile = payload;
	},
};

export const UrlMutations: MutationTree<LtFramework.IUrlState> = {
	setUrl(state: LtFramework.IUrlState, payload: LtFramework.IUrl) {
		state.url = payload;
	},
};
